<template>
  <button
    v-if="isFullscreenVisible"
    @click="tootleFullscreen"
    :aria-label="isFullscreen ? 'Leave fullscreen' : 'Fullscreen'"
    :class="{ 'fullscreen-button--rtl': isLangRtl($i18n.locale) }"
    class="fullscreen-button"
  >
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="2"
        y="2"
        width="28"
        height="28"
        rx="4"
        fill="black"
        fill-opacity="0.3"
      />
      <path
        opacity="0.25"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.5 6C3.5 4.61929 4.61929 3.5 6 3.5H26C27.3807 3.5 28.5 4.61929 28.5 6V26C28.5 27.3807 27.3807 28.5 26 28.5H6C4.61929 28.5 3.5 27.3807 3.5 26V6ZM2 6C2 3.79086 3.79086 2 6 2H26C28.2091 2 30 3.79086 30 6V26C30 28.2091 28.2091 30 26 30H6C3.79086 30 2 28.2091 2 26V6Z"
        fill="white"
      />
      <path
        :d="
          isFullscreen
            ? 'M23.5 14.25C23.9142 14.25 24.25 13.9142 24.25 13.5C24.25 13.0858 23.9142 12.75 23.5 12.75H20.3107L25.5303 7.53033C25.8232 7.23744 25.8232 6.76256 25.5303 6.46967C25.2374 6.17678 24.7626 6.17678 24.4697 6.46967L19.25 11.6893V8.5C19.25 8.08579 18.9142 7.75 18.5 7.75C18.0858 7.75 17.75 8.08579 17.75 8.5V13.5C17.75 13.9142 18.0858 14.25 18.5 14.25H23.5ZM8 17.75C7.58579 17.75 7.25 18.0858 7.25 18.5C7.25 18.9142 7.58579 19.25 8 19.25H11.6893L6.46967 24.4697C6.17678 24.7626 6.17678 25.2374 6.46967 25.5303C6.76256 25.8232 7.23744 25.8232 7.53033 25.5303L12.75 20.3107V24C12.75 24.4142 13.0858 24.75 13.5 24.75C13.9142 24.75 14.25 24.4142 14.25 24V18.5C14.25 18.0858 13.9142 17.75 13.5 17.75H8Z'
            : 'M19 6.75C18.5858 6.75 18.25 7.08579 18.25 7.5C18.25 7.91421 18.5858 8.25 19 8.25H22.6893L17.4697 13.4697C17.1768 13.7626 17.1768 14.2374 17.4697 14.5303C17.7626 14.8232 18.2374 14.8232 18.5303 14.5303L23.75 9.31066V13C23.75 13.4142 24.0858 13.75 24.5 13.75C24.9142 13.75 25.25 13.4142 25.25 13V7.5C25.25 7.08579 24.9142 6.75 24.5 6.75H19ZM12.5 25.25C12.9142 25.25 13.25 24.9142 13.25 24.5C13.25 24.0858 12.9142 23.75 12.5 23.75H9.31066L14.5303 18.5303C14.8232 18.2374 14.8232 17.7626 14.5303 17.4697C14.2374 17.1768 13.7626 17.1768 13.4697 17.4697L8.25 22.6893V19.5C8.25 19.0858 7.91421 18.75 7.5 18.75C7.08579 18.75 6.75 19.0858 6.75 19.5V24.5C6.75 24.9142 7.08579 25.25 7.5 25.25H12.5Z'
        "
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="white"
      />
    </svg>
  </button>
</template>

<script lang="ts">
import { computed, ref } from "vue";
import { useRoute } from "vue-router";
import screenfull from "screenfull";
import { isLangRtl } from "@moderrotech/servers-communication-library/src/helpers/lang";
import { useStore } from "vuex";

export default {
  setup() {
    const store = useStore();
    const config = computed(() => store.state.config.config);

    const styleObject = computed(() => {
      const routeName = useRoute().name;
      const strokeSettingName =
        routeName === "call" ? "appBackgroundColor" : "appBackgroundColor";
      return {
        stroke: config.value[strokeSettingName],
        opacity: screenfull.isEnabled ? 1 : 0.4
      };
    });

    const isFullscreen = ref(false);
    const isFullscreenVisible = screenfull.isEnabled;
    const tootleFullscreen = () => {
      (screenfull as { toggle: Function }).toggle();
      isFullscreen.value = !isFullscreen.value;
    };

    return {
      config,
      isFullscreenVisible,
      isFullscreen,
      tootleFullscreen,
      styleObject,
      isLangRtl
    };
  }
};
</script>

<style lang="scss">
.fullscreen-button {
  //position: absolute;
  //top: 3px;
  //left: 15px;
  //z-index: 2;

  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  background: none;
  border: none;
  outline: none;

  margin-right: -10px;

  svg {
    transform: scale(0.85);
  }

  &--rtl {
    //left: auto;
    //right: 15px;
  }
}
</style>
